export default function MiniCart() {
	const cart = document.querySelector( '.thim-ekits-mini-cart.side-cart' ),
		cartBtn = cart && cart.querySelector( '.minicart-icon' ),
		closePopup = cart && cart.querySelector( '.thim-ekits-mini-cart__close' );

	if (! cart) {
		return;
	}

	const isCartOpen = () => {
		return cart.classList.contains( 'thim-ekits-mini-cart--is-show' );
	};

	const showCart = () => {
		if (isCartOpen()) {
			return;
		}

		cart.classList.add( 'thim-ekits-mini-cart--is-show' );
	};

	const hideCart = () => {
		if (! isCartOpen()) {
			return;
		}

		cart.classList.remove( 'thim-ekits-mini-cart--is-show' );
	};

	const toggleCart = () => {
		if (isCartOpen()) {
			hideCart();
		} else {
			showCart();
		}
	};

	const onKeyDown = ( e ) => {
		if (e.keyCode === 27) {
			hideCart();
		}
	};

	cartBtn && cartBtn.addEventListener( 'click', ( e ) => {
		e.preventDefault();

		toggleCart();
	} );

	document.addEventListener( 'click', ( e ) => {
		if (! isCartOpen()) {
			return;
		}

		const target = e.target;

		if (target.closest( '.thim-ekits-mini-cart__content' ) || target.closest( '.minicart-icon' )) {
			return;
		}

		hideCart();
	} );

	// Click close button.
	closePopup && closePopup.addEventListener( 'click', ( e ) => {
		e.preventDefault();

		hideCart();
	} );

	document.addEventListener( 'keydown', onKeyDown, false ); // click ESC button will hide popup
	jQuery( document.body ).on( 'added_to_cart', showCart ); // WooCommerce is required jQuery
}
